import { useState } from "react";
import { format, startOfMonth, subMonths } from "date-fns";

import Layout from "@/components/layout/Layout";
import { CashFlowStatementHeader } from "@/components/finance/reports/cash-flow-details-new/Header";
import { SummaryCards } from "@/components/finance/reports/cash-flow-details-new/SummaryCards";
import { FinancialReportTable } from "@/components/finance/reports/financial-report/FinancialReportTable";

import {
  useCashFlowStatementDetails,
  type ViewPeriod,
  type DisplayCurrency,
} from "@/hooks/finance/cash-flow/useCashFlow";

export default function FinancialReportPage() {
  const today = format(new Date(), "yyyy-MM-dd");
  const sixMonthsAgo = format(startOfMonth(subMonths(new Date(), 5)), "yyyy-MM-dd");

  const [dateFrom, setDateFrom] = useState(sixMonthsAgo);
  const [dateTo, setDateTo] = useState(today);
  const [viewPeriod, setViewPeriod] = useState<ViewPeriod>("monthly");
  const [displayCurrency, setDisplayCurrency] =
    useState<DisplayCurrency>("ETB");

  const {
    rows,
    periodLabels,
    periodKeys,
    isLoading,
    openingMetaByPeriod,
    closingMetaByPeriod,
  } = useCashFlowStatementDetails(dateFrom, dateTo, viewPeriod, displayCurrency);

  return (
    <Layout>
      <div className="space-y-6 pb-12 animate-in fade-in duration-700">
        <CashFlowStatementHeader
          dateFrom={dateFrom}
          dateTo={dateTo}
          viewPeriod={viewPeriod}
          displayCurrency={displayCurrency}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onViewPeriodChange={setViewPeriod}
          onDisplayCurrencyChange={setDisplayCurrency}
          title="Cash Flow"
          badgeLabel="Monthly CF"
        />

        <SummaryCards
          rows={rows}
          periodKeys={periodKeys}
          displayCurrency={displayCurrency}
          isLoading={isLoading}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />

        <FinancialReportTable
          rows={rows}
          periodLabels={periodLabels}
          periodKeys={periodKeys}
          isLoading={isLoading}
          displayCurrency={displayCurrency}
          openingMetaByPeriod={openingMetaByPeriod}
          closingMetaByPeriod={closingMetaByPeriod}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      </div>
    </Layout>
  );
}
